import { render, staticRenderFns } from "./EDesempenho.vue?vue&type=template&id=719fef63"
import script from "./EDesempenho.vue?vue&type=script&lang=js"
export * from "./EDesempenho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports